import React from 'react'

const Footer = () => {
  return (
    <footer>
      <div className="footer mt-16 bg-gray-700 py-4 text-gray-50">
        <div className="text-center">
          <span>2023 &copy; Made by <a className="font-semibold hover:text-gray-800">Whennnd</a></span>
        </div>
      </div>
    </footer>
  )
}

export default Footer